import useSWR from 'swr';

import myShopClient from '@services/nearlive';

/**
 * Stripe invoice history for `shopId`. Backed by
 * `GET /api/billing/invoices/{shopId}` (`api-handlers/handlers/billing/get-invoice-history.js`).
 * Returns `{ invoices, error, isLoading, mutate }`; `invoices` is `null` until
 * the first response lands, `[]` for customers with no invoices yet.
 *
 * Direct `myShopClient` fetch (not via `dashboard-shared/services/billing`) to
 * avoid the `@nearst/ui` leak guard — mirrors `useBillingStatus`.
 */
export function useInvoices(shopId) {
	const key = shopId ? ['billing-invoices', shopId] : null;
	const { data, error, isLoading, mutate } = useSWR(
		key,
		async () => {
			const client = await myShopClient();
			const { data } = await client.get(`/api/billing/invoices/${shopId}`);
			return data;
		},
		{ revalidateOnFocus: false }
	);

	return { invoices: data ?? null, error, isLoading, mutate };
}
